module.exports = __webpack_public_path__ + "img/js.a00831a7.png";